<template lang="html">
  <v-app>
    <div class="settings-wrapper managers-wrapper">
      <settings :show-delete-button="false" v-on="$listeners" />

      <div class="managers__top">
        <div class="managers__top-row">
          <div class="managers__top-input">
            <vinput
              v-model.trim="searchQuery"
              placeholder="Поиск по пользователям"
              icon="search"
              border
              @keyup.enter="searchByUsers()"
            />
            <div
              v-show="searchQuery.length > 0"
              class="managers__top-clear-icon"
              @click="clearSearchQuery()"
            >
              &times;
            </div>
          </div>

          <vbutton
            text="Добавить пользователя"
            class="managers__top-button"
            @click="addManager()"
          />
        </div>

        <div class="managers__top-row">
          <div class="managers__top-filter-icon" @click.stop="setShowFilter('departments')">
            <icon-filter :color="selectedDepartments.length > 0 ? 'green' : 'grey'" />
          </div>

          <vtfilter
            v-if="showFilter === 'departments'"
            :list="getDepartmentsForSelect"
            :selected_list="filterTempSelectedDepartments"
            class="th_filter managers__top-filter"
            @input="setFilterTempSelectedDepartments"
            @apply="applyFilter('departments')"
            @clear="clearFilter('departments')"
            @cancel="hideFilter()"
          />
        </div>
      </div>

      <div v-if="loading">
        <vpreloader width="2" size="64" />
      </div>

      <div v-else>
        <div v-if="managers.length > 0" class="managers">
          <div v-for="manager in managers" :key="manager.id" class="managers__manager">
            <div class="managers__info">
              <div class="managers__name" @click="editManager(manager.id, manager.role)">
                <span v-if="manager.first_name">{{ manager.first_name }}</span>
                <span v-if="manager.last_name">&nbsp;{{ manager.last_name }}</span>
              </div>
              <div class="managers__contacts">
                <span v-if="manager.email">{{ manager.email }}</span>
                <span v-if="manager.phone">{{ manager.phone }}</span>
              </div>
            </div>

            <div class="managers__role">
              {{ roleText(manager.role) }}
            </div>

            <div v-if="manager.departments.length > 0" class="managers__departments">
              <div
                v-for="department in manager.departments"
                :key="department.id"
                class="managers__department"
                @click="setOneDepartment(department.id)"
              >
                {{ department.name }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <pagination
        v-if="managers.length > 0"
        :params="getManagersPagination"
        :has_load_more="false"
        :loading="$store.state.loading"
        :on-page-change="onPageChange"
        has_counts
        @change_count="onLimitChange"
      />

      <div v-else class="managers">
        <div class="managers__nodata">
          Пользователей не найдено.
          <div>Добавьте нового или уберите все фильтры.</div>
        </div>
      </div>

      <modal-user-edit
        :dialog="modalAddUser"
        :manager-id="managerId"
        @close="modalAddUser = false"
      />
    </div>
  </v-app>
</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex';
  import Settings from '@/routes_new/inner/settings/managers/Settings';
  import Pagination from '@/components_new/complex/vpagination';
  import { STORE_PREFIX } from '@/process/sportmaster/constants';

  export default {
    components: {
      Settings,
      Pagination,
      ModalUserEdit: () => import('./modals/ModalUserEdit')
    },

    data() {
      return {
        modalAddUser: false,
        managerId: null,
        showFilter: '',
        filterTempSelectedDepartments: [],
        searchQuery: ''
      };
    },

    computed: {
      ...mapState(`${STORE_PREFIX}Settings`, ['managers', 'loading', 'selectedDepartments']),

      ...mapGetters(`${STORE_PREFIX}Settings`, ['getManagersPagination', 'getDepartmentsForSelect'])
    },

    async created() {
      await this.$store.dispatch(`${STORE_PREFIX}Settings/fetchAll`);
    },

    methods: {
      ...mapActions(`${STORE_PREFIX}Settings`, [
        'setPage',
        'setSize',
        'makeSearchByUsers',
        'filterManagers',
        'clearFilterManagers'
      ]),

      addManager() {
        this.managerId = null;
        this.modalAddUser = true;
      },

      editManager(managerId, managerRole) {
        // Директор магазина и сотрудник службы безопасности приходят из e-staff поэтому редактировать их нельзя
        if (managerRole === 'shop_director') {
          this.$noty.error(
            `Данный сотрудник импортирован из e-staff. <br /><br />Директоров магазинов и сотрудников службы безопасности нельзя редактировать.`
          );
        } else {
          this.managerId = managerId;
          this.modalAddUser = true;
        }
      },

      roleText(code) {
        switch (code) {
          case 'admin_resercher':
            return 'Администратор';
          case 'resercher':
            return 'Менеджер по персоналу';
          case 'shop_director':
            return 'Директор магазина';
          case 'hr':
            return 'Отдел кадров';
          case 'security':
            return 'Служба безопасности';
          default:
            return 'Роль не определена';
        }
      },

      // pagination
      onPageChange(page) {
        this.setPage(page);
      },

      onLimitChange(size) {
        this.setSize(size);
      },

      setFilterTempSelectedDepartments(model) {
        this.filterTempSelectedDepartments = model.result;
      },

      // filters
      setOneDepartment(departmentId) {
        this.setPage(1);
        this.filterTempSelectedDepartments = [];
        this.filterTempSelectedDepartments.push(departmentId);

        this.applyFilter('departments');
      },

      setShowFilter(filter) {
        this.showFilter = filter;
      },

      hideFilter() {
        this.showFilter = '';
      },

      searchByUsers() {
        this.hideFilter();
        this.makeSearchByUsers(this.searchQuery);
      },

      applyFilter(filterName) {
        let filter = {
          filterName: filterName
        };

        if (filterName === 'departments') {
          filter.filterIds = this.filterTempSelectedDepartments;
        }

        this.filterManagers(filter);
        this.hideFilter();
      },

      clearFilter(filterName) {
        if (filterName === 'departments') {
          this.filterTempSelectedDepartments = [];
        }

        this.clearFilterManagers(filterName);
        this.hideFilter();
      },

      clearSearchQuery() {
        this.searchQuery = '';
        this.searchByUsers(this.searchQuery);
      }
    }
  };
</script>

<style lang="scss" scoped>
  .managers {
    width: 100%;
    margin-top: 20px;
    margin-bottom: 30px;

    &__top {
      display: flex;
      justify-content: space-between;

      .vinput {
        width: 300px;
      }
    }

    &__top-row {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      position: relative;
    }

    &__top-filter-icon {
      width: 40px;
      height: 40px;
      margin-left: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }

    &__top-filter {
      position: absolute;
      right: 0;
      top: 40px;
    }

    &__top-button {
      margin-left: 20px;
    }

    &__top-input {
      position: relative;
    }

    &__top-clear-icon {
      position: absolute;
      top: 0;
      right: 0;
      height: 40px;
      width: 30px;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 20px;
      color: #999;
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: #333;
        transition: color 0.3s;
      }
    }

    &__manager {
      width: 100%;
      padding: 20px 10px;
      border-bottom: 1px solid #eee;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: flex-start;
    }

    &__name {
      font-size: 20px;
      transition: color 0.5s;
      cursor: pointer;

      &:hover {
        color: #4caf50;
        transition: color 0.5s;
      }
    }

    &__info {
      width: 400px;
    }

    &__contacts {
      margin-top: 10px;
      font-size: 14px;
      color: #999;

      span {
        margin-bottom: 5px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    &__role {
      padding-top: 3px;
      width: 250px;
    }

    &__departments {
      width: 600px;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: flex-start;
    }

    &__department {
      display: block;
      height: auto;
      padding: 6px 15px;
      background: #4caf50;
      color: #fff;
      font-size: 14px;
      margin-right: 15px;
      margin-bottom: 7px;
      cursor: pointer;
      transition: background 0.3s;

      &:hover {
        background: darken(#4caf50, 10%);
        transition: background 0.3s;
      }
    }

    &__nodata {
      text-align: center;
      margin: 100px auto;
      font-size: 18px;
      color: #333;

      div {
        color: #999;
        font-size: 14px;
        margin-top: 20px;
      }
    }
  }
</style>
